import { render, staticRenderFns } from "./LoanProvisioning.vue?vue&type=template&id=32f6445c&"
import script from "./LoanProvisioning.vue?vue&type=script&lang=js&"
export * from "./LoanProvisioning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports